import axios from "axios";

export const getSummaryReport = async (
  campaignId,
  businessUnitId,
  startDate,
  endDate
) => {
  const data = await axios.get(
    `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/spotify/${campaignId}/summary-report/${businessUnitId}?start_date=${startDate}&end_date=${endDate}`
  );
  return data.data;
};

export const getReportsByDay = async (
  campaignId,
  businessUnitId,
  startDate,
  endDate
) => {
  const data = await axios.get(
    `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/spotify/${campaignId}/reports-by-day/${businessUnitId}?start_date=${startDate}&end_date=${endDate}`
  );
  return data.data;
};
